import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import DotDotDot from 'react-dotdotdot';
import SimpleRenderer from '../simple-renderer';
import styles from './content-excerpt.scss';

const ContentExcerpt = ({ content, query, type }) => {
  const className = classNames(styles.container, styles[type]);
  return (
    <div className={className} data-hook="post-description">
      <DotDotDot clamp={4}>
        <SimpleRenderer contentState={content} query={query}/>
      </DotDotDot>
    </div>
  );
};

ContentExcerpt.SMALL = 'small';
ContentExcerpt.MEDIUM = 'medium';
ContentExcerpt.LARGE = 'large';
ContentExcerpt.LARGE = 'search';

ContentExcerpt.propTypes = {
  content: PropTypes.object.isRequired,
  query: PropTypes.string,
  type: PropTypes.string,
};

export default ContentExcerpt;



// WEBPACK FOOTER //
// ./app/components/content-excerpt/content-excerpt.js